import React from "react";
import { Divider } from "primereact/divider";
import LandingPage from "./results/LandingPage"; // Import the Landing Page
import AnalysisPage from "./results/AnalysisPage"; // Import the Analysis Page
import ReportPage from "./results/ReportPage"; // Import the Report Page
import PlotPage from "./results/PlotPage";

const ExperimentalTab = () => {
    return (
        <div className="p-p-4" style={{ fontFamily: "Arial, sans-serif" }}>
            <h1>QA Automation Dashboard</h1>
            <p>This dashboard consolidates Landing, Analysis,Report Pages and Plot Pages. (proposal)</p>
            
            {/* Landing Page Section */}
            <section>
                <LandingPage />
            </section>

            <Divider />

            {/* Report Page Section */}
            <section>
                <ReportPage />
            </section>

            <Divider />

            {/* Analysis Page Section */}
            <section>
                <AnalysisPage />
            </section>

            <Divider />

            {/* Report Page Section */}
            <section>
                <PlotPage />
            </section>

        </div>
    );
};

export default ExperimentalTab;
